import { ConfirmationModal as ConfirmationModalLib } from "@stormwater-software/lib-ui";

export const ConfirmationModal = ConfirmationModalLib;

export default ConfirmationModal;
